import { message } from 'antd';
import api from './api';

export const getParametrosGerais = async () => {
  try {
    const { data } = await api.get('/parametrosGerais');
    return { data };
  } catch (error) {
    message.error('Não foi possível buscar os dados de parâmetros gerais.');
    return { error };
  }
};

export const postParametrosGerais = async ({ payload }) => {
  try {
    const { data } = await api.post('/parametrosGerais', payload);
    message.success('Parâmetros gerais alterado com sucesso!');
    return { data };
  } catch (error) {
    message.error('Não foi possível alterar os parâmetros gerais.');
    return { error };
  }
};
